module.exports = __webpack_public_path__ + "static/media/chuck.c014f241.jpg";